import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { XpoLtlDmsUtilsModule } from '@xpo/ngx-ltl';
import { DocumentViewerComponent } from './document-viewer.component';

const components = [DocumentViewerComponent];
@NgModule({
  declarations: [...components],
  exports: [...components],
  entryComponents: [...components],
  imports: [CommonModule, MatTooltipModule, MatIconModule, XpoLtlDmsUtilsModule],
})
export class DocumentViewerModule {}
